import { AlertTriangle, CalendarCheck, CheckCheck, CheckCircle2, Clock, FileCheck2, HelpCircle, Inbox, Minus, Phone, Stethoscope, XCircle } from "lucide-react";
import { DRINGLICHKEIT, STATUS } from "../lib/format";

const TONE = {
  info: "bg-info-bg text-info",
  primary: "bg-primary-light text-primary",
  query: "bg-query-bg text-query",
  danger: "bg-danger-bg text-danger",
  success: "bg-success-bg text-success",
  warning: "bg-warning-bg text-text",
};

const STATUS_STYLE: Record<string, [keyof typeof TONE, any]> = {
  EINGEGANGEN: ["info", Inbox],
  ANGENOMMEN: ["primary", CheckCircle2],
  RUECKFRAGE: ["query", HelpCircle],
  ABGELEHNT: ["danger", XCircle],
  PATIENT_KONTAKTIERT: ["primary", Phone],
  TERMIN_VEREINBART: ["primary", CalendarCheck],
  BEHANDELT: ["success", Stethoscope],
  BERICHT_VERSENDET: ["success", FileCheck2],
  ABGESCHLOSSEN: ["success", CheckCheck],
};

const DR_STYLE: Record<string, [keyof typeof TONE, any]> = {
  SCHMERZFALL: ["danger", AlertTriangle],
  ZEITNAH: ["warning", Clock],
  NORMAL: ["info", Minus],
};

function Badge({ tone, Icon, label, testid }: { tone: keyof typeof TONE; Icon: any; label: string; testid?: string }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-sm font-medium ${TONE[tone]}`}>
      <Icon className={`h-4 w-4 ${tone === "warning" ? "text-warning" : ""}`} aria-hidden />
      {label}
    </span>
  );
}

export function StatusBadge({ status, testid }: { status: string; testid?: string }) {
  const [tone, Icon] = STATUS_STYLE[status] || ["info", Inbox];
  return <Badge tone={tone} Icon={Icon} label={STATUS[status] || status} testid={testid} />;
}

export function UrgencyBadge({ value, testid }: { value: string; testid?: string }) {
  const [tone, Icon] = DR_STYLE[value] || DR_STYLE.NORMAL;
  return <Badge tone={tone} Icon={Icon} label={DRINGLICHKEIT[value] || value} testid={testid} />;
}

export const STATUS_ICON = (s: string) => (STATUS_STYLE[s] || STATUS_STYLE.EINGEGANGEN)[1];
